import { Chip, Typography } from '@mui/material';
import {
  getPartnerAddedFromLabel,
  normalizePartnerAddedFrom,
  PARTNER_ADDED_FROM_STYLES,
} from '../../utils/partnerAddedFrom';

const PartnerAddedFromBadge = ({ addedFrom }) => {
  const normalized = normalizePartnerAddedFrom(addedFrom);
  const label = getPartnerAddedFromLabel(addedFrom);

  if (!label) {
    return (
      <Typography variant="body2" color="text.secondary">
        —
      </Typography>
    );
  }

  const style = PARTNER_ADDED_FROM_STYLES[normalized];

  return (
    <Chip
      label={label}
      size="small"
      sx={{
        height: 24,
        fontWeight: 600,
        fontSize: '0.75rem',
        bgcolor: style.chipBackgroundColor,
        color: style.chipColor,
        borderRadius: '6px',
      }}
    />
  );
};

export default PartnerAddedFromBadge;
